import { useContext } from 'react';

import { SandboxUiContext } from '../utils';

export const useSandboxUiContext = () => {
  return useContext(SandboxUiContext);
};
